import React from "react";
import { VStack } from "../utils";

type SummaryMetricCardProps = {
  label: string;
  value: React.ReactNode;
};

export function SummaryMetricCard({ label, value }: SummaryMetricCardProps) {
  return (
    <VStack className="rounded-lg border border-gray-200 p-4 shadow-custom">
      <p className="p-1 text-sm font-normal form-label">{label}</p>
      <p className="pl-4 pr-8 text-center text-base font-normal">{value}</p>
    </VStack>
  );
}
